Layout.store.actions = {
    setMenuExpanded({commit}, value) {
        commit("setMenuExpanded", value)
    }
};